import React from 'react';

const BorderBox = ({
  name,
  className = '',
  style,
  top,
  left,
  right,
  bottom,
  children
}) => {
  return (
    <div className={`${name}-outer position-relative ${className}`} style={style}>
      <div className="left" style={left ? {
        position: 'absolute',
        display: 'block',
        top: '0px',
        left: '0px',
        height: '100%',
        ...left,
        // background: linear-gradient(180deg, #C8E5FF 0%, #E8F5FF 100%);
      } : {}}></div>
      <div className="right" style={right ? {
        position: 'absolute',
        display: 'block',
        top: '0px',
        right: '0px',
        height: '100%',
        ...right,
      } : {}}></div>
      <div className="top" style={top ? {
        position: 'absolute',
        display: 'block',
        left: '0px',
        right: '0px',
        top: '0px',
        ...top,
      } : {}}>
        <div className="top-2" style={bottom ? {
          position: 'absolute',
          left: left ? left.width : '0px',
          right: right ? right.width : '0px',
          top: '0px',
          height: '100%',
        } : {}}>
          <img className="h-100 w-100" src={`/assets/img/${name}-top-2.png`}/>
        </div>
        <img src={`/assets/img/${name}-top-1.png`}  style={{
          position: 'absolute',
          left: '0px',
          top: '0px',
          height: '100%',
        }}/>
        <img src={`/assets/img/${name}-top-3.png`}  style={{
          position: 'absolute',
          right: '0px',
          top: '0px',
          height: '100%',
        }}/>
      </div>
      <div className="bottom" style={bottom ? {
        position: 'absolute',
        display: 'block',
        left: '0px',
        right: '0px',
        bottom: '0px',
        ...bottom,
      } : {}}>
        <div className="bottom-2" style={bottom ? {
          position: 'absolute',
          left: left ? left.width : '0px',
          right: right ? right.width : '0px',
          bottom: '0px',
          height: '100%',
        } : {}}>
          <img className="h-100 w-100" src={`/assets/img/${name}-bottom-2.png`}/>
        </div>
        <img src={`/assets/img/${name}-bottom-1.png`} style={{
          position: 'absolute',
          left: '0px',
          bottom: '0px',
          height: '100%',
        }}/>
        <img src={`/assets/img/${name}-bottom-3.png`} style={{
          position: 'absolute',
          right: '0px',
          bottom: '0px',
          height: '100%',
        }}/>
      </div>
      <div className={`${name}-inner`} style={{
        ...(top && top.height ? {paddingTop: top.height} : {}),
        ...(left && left.width ? {paddingLeft: left.width} : {}),
        ...(right && right.width ? {paddingRight: right.width} : {}),
        ...(bottom && bottom.height ? {paddingBottom: bottom.height} : {}),
      }}>
        {children}
      </div>
    </div>
  )
}

export default BorderBox;
